import { getDocUrlApi } from '@api/common';

const optionsStore = {
  state: {
    homeland_id: undefined,
    botList: undefined,
    docMap: {}
  },
  mutations: {
    setBotList(state, value) {
      state.botList = value;
    },
    setDocMap(state, value) {
      state.docMap = value;
    },
    setHomelandId(state, value) {
      state.homeland_id = value;
    }
  },
  actions: {
    async getDoc({ commit }, params = {}) {
      const query = params.channel ? { channel: params.channel } : {};
      const res = await getDocUrlApi(query);
      commit('setDocMap', res);
      return res;
    }
  },
  getters: {
    botListHomelandId: state => state.homeland_id,
    botList: state => state.botList
  }
};

export default optionsStore;
